export default {
  'DisplayName': {
    label: 'Available Statements',
    compose: filePath,
    width: 10
  },

  'CreatedDate': '_',

  'AccountId': '_',

  'PathWithName': '_',

  'StartDate': '_',

  'EndDate': '_'
}

function filePath(p) {
  if (!p.data) return ''

  return `<a title="Open ${p.value}"
             href="${global.app.api.$.privateResources}${p.data.PathWithName}"
             target="_blank"
             rel="noopener noreferrer"
             data-action="goto">
             ${p.value}
         </a>`
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-account-statements/model.js